import { useNavigate } from "react-router-dom";
import { PageShell } from "@/components/PageShell";
import { BrandHeader } from "@/components/BrandHeader";
import { Button } from "@/components/Button";
import "./edge.css";

export function NotFoundScreen() {
  const navigate = useNavigate();
  return (
    <PageShell header={<BrandHeader />}>
      <section className="wp-edge">
        <div className="wp-edge__glyph" aria-hidden="true">?</div>
        <h1 className="wp-edge__title">Сторінку не знайдено</h1>
        <Button onClick={() => navigate("/")}>На головну</Button>
      </section>
    </PageShell>
  );
}
